import React from 'react';
import Image from 'next/image';
import { getImgUrl } from '@utils/functions/getImgUrl';

const StudentTestimonialsCard = ({
  avatar,
  name,
  designation = '',
  companyLogo,
  description,
  isDarkTheme,
  earning,
  imagePath = '',
}) => {
  return (
    <div
      className={`m-4 overflow-hidden rounded-xl rounded-md ${
        isDarkTheme ? 'border  border-gray-200 border-opacity-20 bg-[#1A1A1A]' : 'bg-light-gray-2'
      } px-4 py-6`}
    >
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-x-4">
          <Image
            src={imagePath || getImgUrl(avatar)}
            height={80}
            width={80}
            className={`rounded-full ${isDarkTheme ? 'bg-white' : ''}`}
            loading="lazy"
          />
          <div className="font-satoshi-bold">
            <p
              className={`text-medium ${earning ? 'text-lg' : ''} font-satoshi-bold font-bold  ${
                isDarkTheme ? 'text-white' : 'text-black'
              }`}
            >
              {name}
            </p>
            {designation && (
              <p className="font-satoshi-medium text-xs text-gray">
                {designation?.trim() || 'Jr. Data Analyst'}
              </p>
            )}

            {earning && (
              <p className="text-start font-satoshi-medium text-[14px] font-semibold leading-5 text-[#17B26A]">
                🎉 earned ₹{earning?.toLocaleString('en-IN')}
              </p>
            )}
          </div>
        </div>

        {companyLogo && (
          <div>
            <Image
              src={getImgUrl(companyLogo)}
              height={40}
              width={110}
              className=""
              loading="lazy"
            />
          </div>
        )}
      </div>
      <div className="mt-4"></div>
      <div className="flex w-full items-center justify-start">
        <Image src="/assets/images/Placement Statistics/commas.svg" height={20} width={20} />
      </div>
      <p
        className={`text-lg ${
          isDarkTheme ? 'text-gray-subtitle' : 'text-black'
        } font-satoshi-medium`}
      >
        {description}
      </p>
    </div>
  );
};

export default StudentTestimonialsCard;
